import { mapGetters, mapState } from 'vuex';

import formatPhoneNumber from '@shared/lib/formatter/formatPhoneNumber';
import formatterMixin from '@shared/mixins/formatterMixin';
import orderStatusMixin from './orderStatusMixin';

const partnerDetailMixin = {
  mixins: [orderStatusMixin, formatterMixin],
  computed: {
    ...mapState({
      partner: (state) => state.partnerDetail.partner,
      partners: (state) => state.partner.partners,
      partnerSettings: (state) => state.partnerDetail.partnerSettings,
      serviceCategoryList: (state) => state.partnerDetail.serviceCategoryList,
      states: (state) => state.general.states,
      countries: (state) => state.general.countries,
      products: (state) => state.general.products,
      allProducts: (state) => state.general.allProducts,

      loading: (state) => state.partnerDetail.loading,
      loadingOrder: (state) => state.partnerDetail.loadingOrder,
      loadingDevice: (state) => state.partnerDetail.loadingDevice,
      activeTab: (state) => state.partnerDetail.activeTab,
      orders: (state) => state.partnerDetail.orders.filter((o) => o.orderLine.length > 0),
      currentSA: (state) => state.partnerDetail.currentShippingAddress,
      shippingAddresses: (state) => state.partnerDetail.shippingAddresses,
      devices: (state) => state.partnerDetail.devices,
      newShipments: (state) => state.partnerDetail.newShipments,
      orderCreating: (state) => state.partnerDetail.orderCreating,

      actionModalView: (state) => state.partnerDetail.actionModalView,
      showActionModal: (state) => state.partnerDetail.showActionModal,
      partnerIndustry: (state) => state.partner.partnerIndustry,
      errorObj: (state) => state.partnerDetail.errorObj,
      alertTypes: (state) => state.setting.alertTypes,
      taxExemptCategory: (state) => state.setting.taxExemptCategory,
      partnerOrderShippingId: (state) => state.partnerDetail.partnerOrderShippingId,
      partnerOrder: (state) => state.partnerDetail.partnerOrder,
      shippingTotal: (state) => state.partnerDetail.shippingTotal,
      replacement: (state) => state.partnerDetail.replacement,
      requestorId: (state) => state.partnerDetail.requestorId,
      partnerAgreement: (state) => state.partnerAgreement.newAgreement,
      agreements: (state) => state.partnerDetail.agreements,
      selectedCorpId: (state) => state.admin.adminFilter.corpId,
      adminFilter: (state) => state.admin.adminFilter,
      isPilot: (state) => state.partnerDetail.isPilot,
      shippingEditing: (state) => state.partnerDetail.shippingEditing,
    }),
    ...mapGetters([
      'orderSummary',
      'isSmacAdmin',
      'adminRole',
      'waterSensor',
      'comfortSensor',
      'shippingCharges',
      'filterSensor',
      'calcTotalInvoice',
      'getTax',
      'getSubTotal',
      'getTotal',
    ]),
  },
  methods: {
    isValidOrder(order) {
      const {
        productId,
        quantity,
        total,
        sku,
      } = order;
      const product = this.products.find((p) => p.id === productId);
      const skuRequired = product?.sku.includes('PM')
        || (product?.sku.includes('CS') && product?.category === 'Sensors')
        || (product?.sku.includes('FS') && product?.category === 'Sensors')
        || (product?.sku.includes('WS') && product?.category === 'Sensors');
      return !!(productId && quantity && total && ((skuRequired && sku) || !skuRequired));
    },
    changePartnerDetailInfo(field, value) {
      this.$store.dispatch('changePartnerDetailInfo', {
        field,
        value,
      });
    },
    onChangeAgreement(f, v) {
      const updatedPa = { ...this.partnerAgreement, [f]: v };
      this.$store.dispatch('changePartnerDetailInfo', {
        field: 'partnerAgreement',
        value: updatedPa,
      });
    },
    async changeNewShipments(value) {
      await this.$store.dispatch('changePartnerDetailInfo', {
        field: 'newShipments',
        value,
      });
      await this.$store.dispatch('getPartnerOrderTax');
    },
    createPartnerOrderV2(order) {
      this.$store.dispatch('createPartnerOrderV2', {
        order,
      });
    },
    changeShippingAddress(idx, field, value) {
      let v = value;

      if (field === 'phone') {
        v = formatPhoneNumber(value);
      }

      this.$store.dispatch(
        'changePartnerDetailInfo',
        {
          field: 'shippingAddress',
          value: {
            idx,
            field,
            value: v,
          },
        },
      );
    },
    async createPartnerOrder(payload) {
      const order = await this.$store.dispatch('createPartnerOrder', payload);
      if (order) {
        this.$router.push(`/order/partner/${order.orderNumber}`);
      }
    },
    toggleActionModal(show, view) {
      if (!show) {
        this.$store.dispatch('closePartnerDetailActionModal');
      } else {
        const changes = [{
          field: 'showActionModal',
          value: show,
        }, {
          field: 'actionModalView',
          value: view,
        }];
        this.$store.dispatch('changePartnerDetailValues', changes);
      }
    },
  },
};

export default partnerDetailMixin;
